import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import { Box, Modal } from '@mui/material';
import { FC, ReactNode, useRef, useState } from 'react';

import { useOutsideClick } from '../common/OutsideClick/OutsideClick';
import { IWithModal } from '../hoc/withModal';

import { Icon } from './Icon';

interface ICustomModalProps {
  children: ReactNode;
}
export const CustomModal: FC<IWithModal & ICustomModalProps> = ({ children, onClose, open, onClick }) => {
  const style = {
    position: `absolute`,
    right: '7px',
    top: 'calc(100vh - 179px)',
    backgroundColor: `#001a34`,
    width: `220px`,
    height: `auto`,
    color: `white`,
    fontSize: `11px`,
    padding: '16px 28px 16px 16px',
    borderRadius: '16px',
    display: 'flex',
    columnGap: '8px',
  };
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, onClose, open);
  return (
    <Modal
      open={open}
      disableEnforceFocus
      disableAutoFocus
      onClose={onClose}
      disableScrollLock
      hideBackdrop
      disablePortal
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      BackdropProps={{
        timeout: 5000,
      }}
    >
      <Box sx={style} ref={ref}>
        <ReportProblemRoundedIcon />
        {children}
        <div style={{ position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' }}>
          <Icon variant="close" onClick={onClick} />
        </div>
      </Box>
    </Modal>
  );
};
